<!-- 表格
  TableParam:{
    primaryBtn:{ // 绿色按钮的Btn
      html:'' // 按钮名称，可加icon |  <i class="el-icon-plus"></i>新建
    },
    defaultBtn:{ // 默认按钮的Btn
      html:''
    }
    handle: true, 如果需要操作列，则需要设置
    type:event 为点击列
    type:itemEvent 为个别点击，不是整体列，根据数据判断即可。需要手动根据数据给item添加  event: {
            use: true,
            handle: () => { this.listDialog.show = true }
          }
    { prop: 'i', label: '适用店铺', type: 'event', handle: () => { this.listDialog.show = true } }

    column:{
      type：selection //为选择列 当type为 selection 时，需要给 TableParam设置 selectionHandle属性，属性是个函数
      type: event// 点击列
      type: itemEvent // 列个别点击
    }
  }
-->

<template>
  <div class='container'>
    <div :class="[TableParam.paddingRight ? 'tableHeader2' : 'tableHeader']"
          v-if="TableParam.isHeader !== false">
      <span v-if="!TableParam.title">列表</span>
      <span v-if="TableParam.title">{{TableParam.title}}</span>
      <div class="btnContainer">
        <el-checkbox 
          style="margin-right:10px" 
          v-if="TableParam.defaultCheckBox" 
          v-model="TableParam.defaultCheckBox.data" 
          @change="(val)=>{ TableParam.defaultCheckBox.handle(val) }">
            只显示成功绑卡
        </el-checkbox>
        <div v-if="TableParam.defaultFaceCheckBox" style="display: inline-flex;margin-right: 60px;align-items: center;">
            <el-checkbox  
              v-model="TableParam.defaultFaceCheckBox.defaultFaceChecked">
                使用默认面值（元）：
            </el-checkbox>
            <el-input size="mini" type="number" v-model="TableParam.defaultFaceCheckBox.defaultFaceInput" :disabled="!TableParam.defaultFaceCheckBox.defaultFaceChecked"></el-input>
        </div>
        <el-button size="small"
                   v-if="TableParam.defaultBtn"
                   v-html="TableParam.defaultBtn.html"
                   @click="()=>{
                     TableParam.defaultBtn.handle(this.$refs.multipleTable)
                   }"></el-button>
        <el-button type="primary"
                   size="small"
                   v-if="TableParam.primaryBtn"
                   v-html="TableParam.primaryBtn.html"
                   @click="()=>{
                     TableParam.primaryBtn.handle(this.$refs.multipleTable)
                   }"></el-button>
        <slot v-if="TableParam.btnSlot" name="BtnSlot"></slot>
      </div>
    </div>
    <el-table :data="TableParam.data"
              style="width: 100%"
              :max-height="TableParam.maxHeight || null"
              :header-cell-style="{background:'#FAFAFA',color:'#606266'}"
              ref="multipleTable"
              :row-key="getRowKey"
              @selection-change="(v)=>{
                TableParam.selectionHandle && TableParam.selectionHandle(v,this.$refs.multipleTable)
              }">
      <template v-for="(config,index) in TableParam.column">
        <el-table-column type="selection"
                         align="center"
                         :reserve-selection="true"
                         v-if="config.type === 'selection'"
                         :key="index+'_selection'"
                         width="100">
        </el-table-column>
        <el-table-column v-else-if="config.type === 'event'"
                         :key="index+'_event'"
                         :prop="config.prop"
                         :label="config.label">
          <template slot-scope="scope">
            <span class="eventStyle"
                  @click="config.handle(scope.row)">{{scope.row[config.prop]}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="config.type === 'itemEvent'"
                         :key="index+'_itemEvent'"
                         :prop="config.prop"
                         :label="config.label">
          <template slot-scope="scope">
            <span :class="scope.row.event.use ? 'eventStyle' : ''"
                  @click="scope.row.event.use && scope.row.event.handle(scope.row)">{{scope.row[config.prop]}}</span>
          </template>
        </el-table-column>
        <!-- 充值金额 -->
        <el-table-column v-else-if="config.type === 'amount'"
        align="center"
                         :key="index+'_amount'"
                         :prop="config.prop"
                         :label="config.label">
          <template slot-scope="scope">
            <el-input  type="number" :disabled="TableParam.defaultFaceCheckBox.defaultFaceChecked" v-model="scope.row.amount"  @input="$emit('amountChange',scope.row)" />
            <!-- <el-form :model="scope.row" :rules="{amount:[{type: 'number',max:99999999,message: '数字值不大于9999999999.99', trigger:['blur', 'change']},]}" ref="myTableForm" >
             <el-form-item prop="amount">
                    <el-input   v-model.number="scope.row.amount"  @input="$emit('amountChange',scope.row)" style="width:100px"></el-input>
             </el-form-item>
        </el-form> -->
          </template>
        </el-table-column>
        <!-- 充值管理的动态充值管理状态 处理成红色 -->
        <el-table-column v-else-if="config.prop=='statusName'"
                         align="center"
                         :key="index+'_common'"
                         :width="config.width"
                         :prop="config.prop"
                         :label="config.label">
                <template slot-scope="scope">
                  <span :style="{color:scope.row.statusName=='驳回'?'red':''}">{{scope.row.statusName}}</span>
                </template>
        </el-table-column>
        <el-table-column v-else-if="config.slot"
                         align="center"
                         :label="config.label"
                         :width="config.width"
                         :prop="config.prop"
                         :key="index+'_common'">
          <template slot-scope="scope">
            <slot :name="config.prop" :item="scope.row"></slot>
          </template>
        </el-table-column>
        <el-table-column v-else
                         align="center"
                         :key="index+'_common'"
                         :width="config.width"
                         :prop="config.prop"
                         :label="config.label">
        </el-table-column>

      </template>
      <el-table-column label="操作"
                       v-if="TableParam.handle"
                       :width="TableParam.handleWidth">
        <template slot-scope="scope">
          <slot name="handle"
                :item="scope.row"></slot>
        </template>

      </el-table-column>
    </el-table>

    <slot name='Paging'></slot>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  props: {
    TableParam: {
      type: Object,
      required: true
    }
  },
  data () {
    // 这里存放数据
    return {
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getRowKey (row) {
      return row.id
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.container {
  background-color: #fff;
  margin: 0 20px;
  padding: 0 20px;
  border-radius: 10px;
  padding-bottom: 40px;
  flex: 1;
  text-align: center;
  ::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
  }
  .tableHeader {
    width: 100%;
    height: 60px;
    padding-right: 80px;
    box-sizing: border-box;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
  }
  .tableHeader2 {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
  }
  .Paging {
    margin-top: 40px;
  }
  .eventStyle {
    color: #5c6be8;
    cursor: pointer;
  }
  ::v-deep .el-table__header-wrapper {
    border: 1px solid rgb(238, 238, 238);
    border-bottom: none;
    border-left: none;
  }
}
</style>
